// libraries
import type { FSA, SimpleFSA } from '@makemydeal/dr-browser-utils';
import type { IDetailedAuditLog } from '@makemydeal/dr-platform-types';

export const DEAL_CHANGE_LOG_REQUEST = 'DEAL_CHANGE_LOG_REQUEST';
export const DEAL_CHANGE_LOG_SUCCESS = 'DEAL_CHANGE_LOG_SUCCESS';
export const DEAL_CHANGE_LOG_FAILURE = 'DEAL_CHANGE_LOG_FAILURE';

export const DOWNLOAD_AUDIT_LOG_REQUEST = 'DOWNLOAD_AUDIT_LOG_REQUEST';
export const DOWNLOAD_AUDIT_LOG_SUCCESS = 'DOWNLOAD_AUDIT_LOG_SUCCESS';
export const DOWNLOAD_AUDIT_LOG_FAILURE = 'DOWNLOAD_AUDIT_LOG_FAILURE';

export type FetchDealChangeLogSuccessPayload = {
    auditLogData: IDetailedAuditLog[];
};
export type FetchDealChangeLogFailurePayload = {
    response?: {
        error?: any | null;
    };
};

export type FetchDealChangeLogAction = SimpleFSA<typeof DEAL_CHANGE_LOG_REQUEST>;
export type FetchDealChangeLogSuccessAction = FSA<typeof DEAL_CHANGE_LOG_SUCCESS, FetchDealChangeLogSuccessPayload>;
export type FetchDealChangeLogFailureAction = FSA<typeof DEAL_CHANGE_LOG_FAILURE, FetchDealChangeLogFailurePayload>;
export type DownloadAuditLogAction = FSA<typeof DOWNLOAD_AUDIT_LOG_REQUEST, { version?: string }>;
export type DownloadAuditLogSuccessAction = SimpleFSA<typeof DOWNLOAD_AUDIT_LOG_SUCCESS>;
export type DownloadAuditLogFailureAction = SimpleFSA<typeof DOWNLOAD_AUDIT_LOG_FAILURE>;

export type DealAuditLogActions =
    | FetchDealChangeLogAction
    | FetchDealChangeLogSuccessAction
    | FetchDealChangeLogFailureAction
    | DownloadAuditLogAction
    | DownloadAuditLogSuccessAction
    | DownloadAuditLogFailureAction;
